import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useModal } from "@/contexts/ModalContext";

interface AddNoteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  leadId: string;
  onSave: (content: string) => void;
}

export function AddNoteDialog({ open, onOpenChange, leadId, onSave }: AddNoteDialogProps) {
  const [note, setNote] = useState("");
  const { registerModal, unregisterModal } = useModal();

  useEffect(() => {
    if (!open) return;
    registerModal('lead-note-dialog', () => onOpenChange(false), 1);
    return () => unregisterModal('lead-note-dialog');
  }, [open, onOpenChange, registerModal, unregisterModal]);

  const handleSubmit = () => {
    if (!note.trim()) {
      toast.error("Please enter a note");
      return;
    }
    onSave(note);
    toast.success("Note added to timeline");
    setNote("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Add Note</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <Textarea
            placeholder="Enter your note here..."
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={5}
            className="resize-none rounded-xl"
          />
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-xl">
            Cancel
          </Button>
          <Button onClick={handleSubmit} className="rounded-xl">Add Note</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
